// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__2dQfB","Logo":"styles_Logo__2_9LZ","about":"styles_about__1njIW","random":"styles_random__1Rq2n","menuIcon":"styles_menuIcon__2in7H"};